import { render, staticRenderFns } from "./supercHotelOrder.vue?vue&type=template&id=7864817a&"
import script from "./supercHotelOrder.vue?vue&type=script&lang=js&"
export * from "./supercHotelOrder.vue?vue&type=script&lang=js&"
import style0 from "./supercHotelOrder.vue?vue&type=style&index=0&id=7864817a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports